import React, { useState, useEffect } from 'react';

// import { ClickAwayListener } from '@material-ui/core';

import { useSelector, useDispatch } from 'react-redux';
import jwt from 'jsonwebtoken';
import { Grid, Hidden } from '@material-ui/core';
import {
  getUserNotifications,
  readNotifications,
  viewNotification,
} from '../../actions/settings/notifications-actions';
import socket from '../../utils/socket';
// import sound from '../../assets/sounds/notification.wav';

import NotificationContent from './NotificationContent';
import NotificationBadge from './NotificationBadge';
import IconsMobile from '../../pages/Dashboard/Components/IconsMobile/IconsMobile';
// import NotificationAudio from 'notification.mp3';
// import { ReactComponent as NotificationIcon } from '../../images/dashbaordNoti.svg';

export default function index({ isMainScreen }) {
  const dispatch = useDispatch();
  const { userNotifications } = useSelector((s) => s?.settings);
  const [notificationOpen, setNotificationOpen] = useState(false);
  // const [notificationOpen, setNotificationOpen] = useState(false);
  const [allNotifications, setAllNotifications] = useState([]);
  const [pendingNotifications, setPendingNotifications] = useState([]);
  const [newNotificationData, setNewNotification] = useState();
  const [updatedNotification, setUpdatedNotification] = useState();
  const [deletedNotificationsRes, setDeletedNotificationsRes] = useState();
  const [audio, setAudio] = useState(null);
  const userDetails = JSON.parse(localStorage.getItem('userData')) || {};
  const { token } = userDetails;
  const tokenData = jwt.decode(token);

  const filterPendingNotifications = (notifications) => {
    const pending = notifications?.filter((not) => not.status === 'pending');
    setPendingNotifications([...pending]);
  };

  useEffect(() => {
    // Create a new Audio object when the component mounts
    const audi1o = new Audio(
      'https://ar-public-feature.s3.amazonaws.com/notification.mp3',
    );
    audi1o.volume = 1.0;
    setAudio(audi1o);
  }, []);

  useEffect(() => {
    if (isMainScreen) {
      setNotificationOpen(true);
    }

    if (userDetails?.userStore) {
      // call api only if user store exists
      dispatch(getUserNotifications());
    }

    socket.emit('connection', () => {});
    if (tokenData?.coUserId && tokenData?.userId) {
      const rooms = [];
      const room = (tokenData?.userId + '-' + tokenData?.coUserId)?.toString();
      rooms.push(room);

      // socket.emit('join_notification_room', {
      //   room: rooms,
      // });
      socket.emit('join_room', {
        room: rooms,
      });
      socket.on('newNotification', (notificationData) => {
        if (notificationData) {
          if (notificationData?.status === 'pending') {
            setNewNotification(notificationData);
          }
        }
      });
      //  if user view the notification
      socket.on('updatedNotification', (updatedNoti) => {
        if (updatedNoti) {
          setUpdatedNotification(updatedNoti);
        }
      });
      //  if user clear the notifications
      socket.on('deletedNotification', (dleted) => {
        if (dleted) {
          setDeletedNotificationsRes(dleted);
          // setUpdatedNotification(updatedNoti);
        }
      });
    }
  }, []);

  useEffect(() => {
    if (userNotifications?.length > 0) {
      const sortedNotifications = userNotifications?.sort((a, b) => {
        return a.id < b.id ? 1 : -1;
      });
      filterPendingNotifications(sortedNotifications);
      setAllNotifications([...sortedNotifications]);
    }
  }, [userNotifications]);

  /* this will run when socket throw updated data
   inside socket state scope is undefined */
  useEffect(() => {
    if (newNotificationData?.id) {
      pendingNotifications.unshift(newNotificationData);
      allNotifications.unshift(newNotificationData);
      setPendingNotifications([...pendingNotifications]);
      setAllNotifications([...allNotifications]);
      audio.play().catch((error) => {
        console.error('Error playing audio:', error);
      });
    }
  }, [newNotificationData]);

  useEffect(() => {
    if (updatedNotification?.id) {
      const foundObjIndex = allNotifications?.findIndex(
        (obj) => obj.id === updatedNotification?.id,
      );
      if (foundObjIndex > -1) {
        allNotifications[foundObjIndex] = updatedNotification;
        setAllNotifications([...allNotifications]);
      }
    }
  }, [updatedNotification]);

  useEffect(() => {
    if (deletedNotificationsRes?.length === 0) {
      setAllNotifications([]);
    }
  }, [deletedNotificationsRes]);
  const onclickNotificationIcon = () => {
    setNotificationOpen(!notificationOpen);
    if (pendingNotifications?.length > 0) {
      pendingNotifications?.map((pen) => {
        pen.status = 'read';
      });
      dispatch(readNotifications({ notifications: pendingNotifications }));
      setPendingNotifications([]);
      setNotificationOpen(!notificationOpen);
    }
  };

  const onclickNotification = (data) => {
    if (!data?.isView) {
      const obj = {
        isView: true,
        notificationId: data?.id,
      };
      dispatch(viewNotification(obj));
    }
    // history.push('/jobboard');
  };

  return (
    <>
      {isMainScreen ? ( // for view all notifications
        notificationOpen && (
          <>
            <NotificationContent
              isMainScreen={isMainScreen}
              notifications={allNotifications || []}
              tokenData={tokenData}
              onclickNotification={onclickNotification}
            />
            <Grid container>
              <Hidden only={['md', 'lg', 'xl']}>
                <IconsMobile />
              </Hidden>
            </Grid>
          </>
        )
      ) : (
        // for layout notification
        <NotificationBadge
          isMainScreen={isMainScreen}
          onclickNotificationIcon={onclickNotificationIcon}
          notificationOpen={notificationOpen}
          pendingNotifications={pendingNotifications}
          allNotifications={allNotifications}
          setNotificationOpen={setNotificationOpen}
          tokenData={tokenData}
          onclickNotification={onclickNotification}
        />
      )}

      {/* <Badge
        className='notificationBadge'
        badgeContent={pendingNotifications?.length}
        color='primary'
        style={{
          cursor: window.location.pathname === '/notifications' && 'default',
        }}
        onClick={
          window.location.pathname === '/notifications'
            ? null
            : onclickNotificationIcon
        }
      >
        <NotificationIcon />
        {notificationOpen && (
          <ClickAwayListener onClickAway={() => setNotificationOpen(false)}>
            <NotificationContent
              isMainScreen={isMainScreen}
              notifications={allNotifications || []}
              tokenData={tokenData}
              onclickNotification={onclickNotification}
            />
          </ClickAwayListener>
        )}
      </Badge> */}
    </>
  );
}
